import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PackageOverviewSection } from './components/PackageOverviewSection';
import { SystemSection } from './components/SystemSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PremiumSection } from './components/PremiumSection';
import { AudienceSection } from './components/AudienceSection';
import { TimelineSection } from './components/TimelineSection';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen bg-[#EFEAE0] text-[#1C3B36]" data-id="element-0" data-mp="3ikr0s4yore8d">
      <main data-id="element-1" data-mp="3ii4qhxkeukmg">
        <HeroSection data-id="element-2" data-mp="3mlavl1vse5rc" />
        <PackageOverviewSection data-id="element-3" data-mp="3mkrchhuehbbq" />
        <SystemSection data-id="element-4" data-mp="3mjq1tehaqquj" />
        <BenefitsSection data-id="element-5" data-mp="3mj6jhwnqi0fz" />
        <PremiumSection data-id="element-6" data-mp="3rbrbcsn2y3gv" />
        <AudienceSection data-id="element-7" data-mp="3rdkisa5iorpx" />
        <TimelineSection data-id="element-8" data-mp="3recerm310rgq" />
        <FAQSection data-id="element-9" data-mp="5yh2n2cyzbp" />
        <TestimonialsSection data-id="element-10" data-mp="67znpl2q47d" />
        <GuaranteeSection data-id="element-11" data-mp="5gfdawxfswe" />
        <PricingSection data-id="element-12" data-mp="7suzhf7pr6a" />
        <FinalCTASection data-id="element-13" data-mp="2zld43f9knpe6" />
      </main>
      <Footer data-id="element-14" data-mp="2zmem63p09c5e" />
      <SocialProofPopup data-id="element-15" data-mp="2zmwhmy3ufmc9" />
    </div>;
}